module.exports = __webpack_public_path__ + "img/BAAC.861fbda4.png";